<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <v-row class="mt-0 mb-2" justify="space-between" no-gutters>
        <v-col cols="12" md="4">
          <v-card class="py-3 px-4 vcard_area">
            <v-row>
              <v-col cols="12" md="7">
                <div class="text-h1 mb-2">Modelos</div>
                <div class="text text--thin mb-2">Os modelos incluídos aqui serão exibidos no cadastro de produtos</div>
                <v-btn v-if="!$root.Permissions.revendor()" @click="dialogNovo = true" color="primary" class="mt-1"><v-icon class="mr-1">assistant</v-icon>Novo modelo</v-btn>
              </v-col>
              <v-col cols="12" md="5" v-if="!$root.Permissions.revendor()">
                <div class="icon_area" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                  <v-icon>add</v-icon>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="dados"
        disable-sort
        :server-items-length="total"
        :options.sync="options"
        loading-text="Carregando... Por favor aguarde"
        :loading="carregando"
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:item.mod_imagem="{ item }">
          <img v-if="item.mod_imagem" class="modelo_logo" :src="item.mod_imagem" :alt="item.mod_nome">
          <div v-else>Não possui</div>
        </template>
        <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between">
            <v-row no-gutters>
              <div class="py-2 px-2">
                <v-form @submit.prevent="applyFilter()">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="search"
                    outlined
                    label="Busca"
                    @click:clear="limparBusca()"
                  ></v-text-field>
                </v-form>
              </div>
              <div class="py-2 px-2" v-if="$root.Permissions.admin()">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="distribuidor"
                  :items="distribuidores"
                  hide-details=""
                  clearable
                  clear-icon="close"
                  label="Distribuidor"
                  append-icon="expand_more"
                  outlined
                  @change="applyFilter()"
                  @click:clear="applyFilter()"
                >
                </v-autocomplete>
              </div>
              <div class="py-2 px-2" v-if="$root.Permissions.admin()">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="integrador"
                  :items="integradores"
                  hide-details=""
                  clearable
                  clear-icon="close"
                  label="Integrador"
                  append-icon="expand_more"
                  outlined
                  @change="applyFilter()"
                  @click:clear="applyFilter()"
                >
                </v-autocomplete>
              </div>
            </v-row>
            <div>
              <v-menu
                bottom
                center
                offset-y
                max-height="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    Exportar
                    <v-icon>arrow_drop_down</v-icon>
                  </div>
                </template>
                <v-list>
                  <v-list-item @click="exportXls()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">receipt_long</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para XLS</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-row>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center"
            v-if="validaPermissao(item)"
          >
            <v-tooltip top v-if="!$root.Permissions.revendor()">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openNovo(item)" color="primary" class="mr-2">
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top v-if="!$root.Permissions.revendor()">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="500px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{modelo.uuid_mod_id ? 'Editar modelo' : 'Novo modelo'}}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formModelos">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
              <v-text-field
                v-model="modelo.mod_nome"
                label="Nome*"
                :rules="[rules.required]"
                autofocus
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-file-input
                show-size
                clearable
                ref="file"
                v-model="modelo.mod_imagem"
                prepend-icon="image"
                label="Adicionar logotipo*"
                clear-icon="close"
                truncate-length="50"
                :loading="salvando"
                :disabled="salvando"
                v-if="isObject(modelo.mod_imagem)"
                outlined
                :rules="[rules.size]"
                hint="Tamanho recomendado: 300x300px"
                persistent-hint
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 mb-6" v-if="modelo.mod_imagem && !isObject(modelo.mod_imagem)">
              <v-row no-gutters justify="start" align="center">
                <div v-if="modelo.mod_imagem">
                  <img alt="Logotipo" :src="modelo.mod_imagem" class="logotipo">
                </div>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="dialogDeletarImagem = true" v-bind="attrs" v-on="on" color="primary">delete</v-icon>
                    </template>
                    <span>Remover logotipo</span>
                  </v-tooltip>
                </div>
              </v-row>
            </v-col>
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditModelos()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeletarImagem" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Logotipo
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogDeletarImagem = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="mb-5">
          Tem certeza que deseja remover o logotipo?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogDeletarImagem = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeImagem()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Modelo
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelModeloDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir modelo <b class="text-primary">{{modelo ? modelo.mod_nome : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="cancelModeloDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :disabled="salvando"
            :loading="salvando"
            @click="removeModelos()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
export default {
  watch: {
    options: {
      handler () {
        this.getModelos()
      },
      deep: true
    }
  },
  data () {
    return {
      loading: true,
      carregando: false,
      salvando: false,
      dialogNovo: false,
      dialogExcluir: false,
      dialogDeletarImagem: false,
      search: '',
      options: {},
      total: 0,
      integrador: null,
      distribuidor: null,
      distribuidorAnterior: null,
      integradores: [],
      distribuidores: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'mod_id',
          width: 150
        },
        { text: 'Nome', value: 'mod_nome' },
        { text: 'Imagem', value: 'mod_imagem' },
        { text: 'Distribuidor', value: 'distribuidor' },
        { text: 'Integrador', value: 'integrador' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dados: [],
      rules: {
        required: value => !!value || 'Obrigatório.',
        min: v => v.length >= 6 || 'Mínimo 6 caracteres',
        size: value => !value || value.size < 10000000 || 'Imagem precisa ter menos que 10MB!'
      },
      modelo: {
        mod_nome: '',
        mod_imagem: ''
      }
    }
  },
  methods: {
    validaPermissao (item) {
      if (this.$root.Permissions.admin()) return true
      if (this.$root.Permissions.distributor() && !item.fk_int_id_integrador && item.fk_dis_id_distribuidor) return true
      if (this.$root.Permissions.integrator() && item.fk_int_id_integrador) return true
      return false
    },
    async exportXls () {
      this.loadingXls = true
      Api.post('relatorios/exportar', {
        headers: this.someHeader(),
        busca: this.search,
        type: 'modelos'
      })
        .then(res => {
          this.downloadXls(res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    someHeader () {
      let cabecalhos = []
      this.headers.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações' && header.text !== 'Usuários' && header.text !== 'Imagem') cabecalhos.push(header)
      })
      return cabecalhos
    },
    removeHeader () {
      if (!this.$root.Permissions.admin()) {
        delete this.headers[3]
        delete this.headers[4]
      }
    },
    loadFunctions () {
      let filters = this.$route.query
      if (filters.busca) this.search = filters.busca
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      this.removeHeader()
      this.getDistributors()
      this.getIntegrators(this.distribuidor)
      this.loading = false
    },
    getDistributors () {
      Api.get('distribuidores')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                value: item.uuid_dis_id,
                text: item.dis_nome_fantasia
              })
            })
            this.distribuidores = info
          }
        })
    },
    async getIntegrators (distribuidor = null, cadastro = false) {
      this.loadingIntegradores = true
      let url = 'integradores'

      if (distribuidor) {
        url = `distribuidores/${distribuidor}/integradores`
      }
      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })
          if (cadastro || (!cadastro && !distribuidor)) {
            this.integradoresCadastro = arrayInt
          }

          if (!cadastro) {
            this.integradores = arrayInt
          }
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    isObject (val) {
      if (val) {
        return val instanceof Object
      } else {
        return true
      }
    },
    limparBusca () {
      this.search = null
      this.options.page = 1
      this.applyFilter()
    },
    applyFilter () {
      if (this.distribuidorAnterior && this.distribuidor !== this.distribuidorAnterior) {
        this.integrador = ''
      }
      this.carregando = true

      let query = Object.assign({},
        this.search ? { busca: this.search } : '',
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.integrador ? { integrador: this.integrador } : ''
      )

      this.$router.replace({name: 'Modelos', query: query}).catch(() => {})

      this.options.page = 1
      this.distribuidorAnterior = this.distribuidor
      this.getIntegrators(this.distribuidor)
      this.getModelos()
    },
    async getModelos () {
      this.carregando = true
      this.total = 0

      const { page, itemsPerPage } = this.options
      let pagina = 1
      let itensPagina = 10
      let endpoint = ''

      if (page) pagina = page
      if (itemsPerPage) itensPagina = itemsPerPage
      if (this.search) endpoint += `&busca=${this.search}`
      if (this.distribuidor && !this.integrador) endpoint += '&distribuidor=' + this.distribuidor
      if (this.integrador) endpoint += '&integrador=' + this.integrador

      await Api.get(`modelos?page=${pagina}&per_page=${itensPagina}${endpoint}`)
        .then(res => {
          let info = []
          if (res.data) {
            if (res.data.data.length > 0) {
              res.data.data.map(item => {
                info.push({
                  uuid_mod_id: item.uuid_mod_id,
                  fk_int_id_integrador: item.fk_int_id_integrador,
                  fk_dis_id_distribuidor: item.fk_dis_id_distribuidor,
                  mod_id: item.mod_id,
                  mod_nome: item.mod_nome,
                  mod_imagem: item.mod_imagem,
                  distribuidor: item.distribuidor ? item.distribuidor.dis_nome : ' - ',
                  integrador: item.integrador ? item.integrador.int_nome : ' - '
                })
              })
            }
            this.total = res.data.total
          }
          this.dados = info
          console.log(this.dados)
          this.loading = false
          this.carregando = false
        })
        .catch(err => {
          this.loading = false
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os modelos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    removeImagem () {
      this.modelo.mod_imagem = ''
      this.modelo.remover_imagem = true
      this.dialogDeletarImagem = false
    },
    saveEditModelos () {
      if (!this.$refs.formModelos.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'modelos/novo'
      let editado = false
      if (this.modelo.uuid_mod_id) {
        endpoint = 'modelos/edita'
        editado = true
      }
      const formData = new FormData()
      Object.keys(this.modelo).map((key) => {
        if (key === 'mod_imagem') {
          if (this.$refs.file) {
            formData.append(`mod_imagem`, this.modelo.mod_imagem)
          }
        } else {
          if (this.modelo[key] != null) {
            formData.append(key, this.modelo[key])
          }
        }
      })
      Api.post(endpoint, formData)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Modelo atualizado com sucesso!' : 'Modelo cadastrado com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getModelos()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeModelos () {
      this.salvando = true
      console.log(this.modelo)
      Api.delete(`modelos/remove/${this.modelo.uuid_mod_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getModelos()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover modelo!',
            color: 'error'
          })
        })
    },
    openNovo (item) {
      this.modelo = JSON.parse(JSON.stringify(item))
      this.dialogNovo = true
    },
    openDialogDelete (item) {
      this.modelo = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    cancelModeloDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    closeDialog () {
      this.modelo = {
        mod_nome: '',
        mod_imagem: ''
      }
      if (this.$refs.formModelos) {
        this.$refs.formModelos.resetValidation()
      }
      this.dialogNovo = false
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.logotipo {
  max-height: 250px;
  max-width: 250px;
}
.v-file-input {
  >>>.v-input__prepend-outer {
    margin-top: 10px!important;
  }
}
.modelo_logo {
  max-height: 100px;
  margin: 5px 0;
  max-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/pages/configuracoes/Modelos.vue